import type { RootState } from '@core/Store'
import { IStructuredSearchResults, StructuredSearchFields } from '.'

export const selectSearchCriteria = (state: RootState): StructuredSearchFields =>
  state.structuredSearch.searchCriteria

export const selectSearchResults = (state: RootState): IStructuredSearchResults =>
  state.structuredSearch.searchResults
